export default __webpack_public_path__ + "static/media/people.395eb078.png";